import { StandardModalHeader } from "@design-system/Modal/Modal";
import { useLoadStripe } from "@hooks/billing/useLoadStripe";
import { useStripeSetupModeOptions } from "@hooks/billing/useStripeSetupModeOptions";
import { Elements } from "@stripe/react-stripe-js";
import { FC } from "react";
import { EnrollOrganizationForm } from "./EnrollOrganizationForm";
import { EnrollActionProps } from "./lib";

export const EnrollOrganizationModal: FC<EnrollActionProps> = ({ action }) => {
    const stripePromise = useLoadStripe();
    const stripeOptions = useStripeSetupModeOptions();

    return (
        <>
            <StandardModalHeader>Enroll your firm</StandardModalHeader>

            <Elements stripe={stripePromise} options={stripeOptions}>
                <EnrollOrganizationForm action={action} />
            </Elements>
        </>
    );
};
